module.exports = __webpack_public_path__ + "0f0db7d2624fd81e2e3aaa109d42a6e9.woff2";